// extracted by mini-css-extract-plugin
export default {"list":"Offers_list__sHkSL","item":"Offers_item__Kcylj","check":"Offers_check__YmbVW","item_text":"Offers_item_text__2LOtA","flareAnimation":"Offers_flareAnimation__0VzaF"};